import { render, staticRenderFns } from "./IdleSessionLogout.vue?vue&type=template&id=19b0ce9c&scoped=true"
import script from "./IdleSessionLogout.vue?vue&type=script&lang=js"
export * from "./IdleSessionLogout.vue?vue&type=script&lang=js"
import style0 from "./IdleSessionLogout.vue?vue&type=style&index=0&id=19b0ce9c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b0ce9c",
  null
  
)

export default component.exports